export const hardCodedTags = {
  DELIVERY_TAG_NAME: 'delivery-fee',
  DELIVERY_TAG_ID: 'delivery_fee',
  OTHER_TAG_TYPE: 'tagtype_other',
  SHARED_TAG_TYPE: 'tagtype_shared',
  VERIFIED_TAG_ID: 'tag_verified',
  VERIFIED_TAG_NAME: 'tag_verified',
  BOOKEDBY_TAG_ID: 'tag_bookedby',
  BOOKEDBY_TAG_NAME: 'Booked by',
};

export const sharedTagIds = {
  membership: 'tag_membership',
  noShow: 'tag_no_show',
  vip: 'tag_vip',
};
